const includesAny = (value, patterns) => patterns.some((pattern) => value.includes(pattern))

const getBounceDetailLabel = ({ reason, errorMessage }) => {
    const normalizedReason = String(reason || '').toLowerCase()
    const normalizedError = String(errorMessage || '').toLowerCase()
    const combined = `${normalizedReason} ${normalizedError}`

    if (includesAny(combined, ['noemail', 'no such user', 'user unknown', 'unknown user', '5.1.1'])) {
        return '존재하지 않는 이메일 주소'
    }
    if (includesAny(combined, ['mailboxfull', 'mailbox full', 'quota exceeded', 'over quota', '5.2.2'])) {
        return '메일함 용량 초과'
    }
    if (includesAny(combined, ['messagetoolarge', 'message too large', '5.3.4'])) {
        return '메일 크기 제한 초과'
    }
    if (includesAny(combined, ['contentrejected', 'attachmentrejected'])) {
        return '메일 내용 또는 첨부파일 거부'
    }
    if (includesAny(combined, ['onaccountsuppressionlist', 'suppressed'])) {
        return 'SES 억제목록 등록 주소'
    }
    if (includesAny(combined, ['5.7.1', 'blocked', 'blocklisted', 'spam', 'policy'])) {
        return '수신 서버 정책 차단'
    }
    if (includesAny(combined, ['domain not found', 'host not found', 'dns'])) {
        return '이메일 도메인 확인 필요'
    }

    return '상세 사유 확인 필요'
}

export const getRecordBounceReason = ({ result, reason, errorMessage } = {}) => {
    if (result !== 'bounced') return null

    const normalizedReason = String(reason || '').toLowerCase()
    let category = '반송'
    if (normalizedReason.startsWith('permanent')) category = '영구 반송'
    if (normalizedReason.startsWith('temporary')) category = '일시적 반송'
    if (normalizedReason.startsWith('undetermined')) category = '원인 미확인 반송'

    return {
        label: `${category} · ${getBounceDetailLabel({ reason, errorMessage })}`,
        sesReason: reason || '',
        smtpReason: errorMessage || '',
    }
}
